import { createFileRoute } from "@tanstack/react-router";
import { LoginLinkPage } from "~/pages/login/login-link";

export const Route = createFileRoute("/_auth/login-link")({
  component: LoginLinkPage,
});
